// extracted by mini-css-extract-plugin
export default {"reset":"u_fwGF","visuallyHidden":"JBXSE3"};